module.exports = __webpack_public_path__ + "img/edit.b8c0a5c1.svg";